import React, { Component } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { RotateLoader } from "react-spinners";
import { Formik, Field, ErrorMessage } from "formik";
import * as yup from "yup";
import { getUserByPhone } from "./../services/blinkai";

export class FormInformation extends Component {
  state = {
    loading: true,
  };

  FormSchema = yup.object().shape({
    firstName: yup.string().min(2, "Too Short!").max(50, "Too Long!").required("I am sure people call you by something"),
    lastName: yup.string().min(2, "Too Short!").max(50, "Too Long!").required("Can I get the last name as well please"),
    email: yup.string().email("Invalid email").required("We will need your email to send confirmation or any other updates related to your appointment"),
  });

  compare = (a, b) => {
    if (a === null && b !== null) {
      return false;
    }
    if (b === null && a !== null) {
      return false;
    }
    return a.toUpperCase() === b.toUpperCase();
  };
  componentDidMount = () => {
    const { storeId, phone, paramFirstName, paramLastName, paramEmail, paramSession, paramCampaignId } = this.props.values;
    const { handleChange } = this.props;
    getUserByPhone(storeId, phone, paramCampaignId, paramSession).then((res) => {
      this.setState({ loading: false });
      const { firstName, lastName, email, storeUserId, firstAvailable, availableCalendar, serviceTypeRequired, pickupOptionEnabled, notesEnabled } = res.data.data;
      console.log("Should Get Service Type", serviceTypeRequired);
      console.log("Should Show Pickup Option", pickupOptionEnabled);
      console.log("Should Show Notes", notesEnabled);
      if (res.data.success) {
        const parsedAvailableCalendar = JSON.parse(availableCalendar);
        let shouldSkipStep = false;

        if (this.compare(paramFirstName, firstName) && this.compare(paramLastName, lastName) && this.compare(paramEmail, email)) {
          shouldSkipStep = true;
        }

        handleChange({
          // we will use the passed param values if it exists
          firstName: this.props.values.firstName !== "" ? this.props.values.firstName : firstName,
          lastName: this.props.values.lastName !== "" ? this.props.values.lastName : lastName,
          email: this.props.values.email !== "" ? this.props.values.email : email,
          storeUserId,
          date: new Date(firstAvailable),
          availableCalendar: parsedAvailableCalendar,
          serviceTypeRequired,
          pickupOptionEnabled,
          notesEnabled,
        });

        if (shouldSkipStep) {
          console.log("Skipping the step 2 as param info matches with our database");
          this.props.nextStep();
        }
      }
    });
  };

  back = (e) => {
    e.preventDefault();
    this.props.prevStep();
  };

  render() {
    let { firstName, lastName, email } = this.props.values;
    firstName = firstName || "";
    lastName = lastName || "";
    email = email || "";
    return (
      <React.Fragment>
        <h3>Your Information</h3>
        <hr />
        <Row>
          <Col>
            {!this.state.loading && (
              <Formik
                enableReinitialize
                initialValues={{
                  firstName,
                  lastName,
                  email,
                }}
                validationSchema={this.FormSchema}
                onSubmit={(values, { setSubmitting }) => {
                  this.setState({ loading: true });
                  let { firstName, lastName, email } = values;
                  this.props.handleChange({
                    firstName,
                    lastName,
                    email,
                  });
                  setSubmitting(false);
                  this.props.nextStep();
                }}
              >
                {({ errors, touched, handleSubmit, isSubmitting }) => (
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col>
                        <Form.Group controlId="formFirstName">
                          <Field
                            type="text"
                            name="firstName"
                            autoComplete="given-name"
                            className={"form-control " + (errors.firstName && touched.firstName && "is-invalid")}
                            placeholder="First Name"
                          />
                          <ErrorMessage name="firstName" component="div" className="form-label invalid-feedback" />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group controlId="formLastName">
                          <Field type="text" name="lastName" autoComplete="family-name" className={"form-control " + (errors.lastName && touched.lastName && "is-invalid")} placeholder="Last Name" />
                          <ErrorMessage name="lastName" component="div" className="form-label invalid-feedback" />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group controlId="formEmail">
                          <Field type="text" name="email" autoComplete="email" className={"form-control " + (errors.email && touched.email && "is-invalid")} placeholder="Email" />
                          <Form.Text>We use your email to send confirmations and reminders. We'll never share your email with anyone else.</Form.Text>
                          <ErrorMessage name="email" component="div" className="form-label invalid-feedback" />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Button size="lg" block variant="primary" type="submit" disabled={isSubmitting}>
                      Select Time
                    </Button>
                  </Form>
                )}
              </Formik>
            )}
            <div className="text-center loader">
              <RotateLoader color={"#337ab7"} loading={this.state.loading} />
            </div>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

export default FormInformation;
